import { PLAN_MAP } from '@/data/plan/plans.js';

export default {
  namespaced: true,

  state: {
    // ★ 起動時にlocalStorageからデータを読み込む
    items: (() => {
      try {
        return JSON.parse(localStorage.getItem('orderHistory')) || [];
      } catch (error) {
        console.error('Failed to parse orderHistory from localStorage:', error);
        return [];
      }
    })(),
  },

  getters: {
    /**
     * 注文履歴の合計金額を算出する
     * @param {object} state - このモジュールのstate
     * @returns {number} 合計金額
     */
    totalHistoryAmount: (state) => (
      (!state.items || state.items.length === 0)
        ? 0
        : state.items.reduce((sum, item) => sum + (item.price * item.quantity), 0)
    ),
  },

  actions: {
    /**
     * 履歴にアイテムを追加するアクション
     * @param {Array} newItems - cartストアから渡されるアイテムの配列
     */
    addItemsFromCart({ commit }, newItems) {
      if (newItems && newItems.length > 0) {
        commit('ADD_ITEMS', newItems);
      }
    },
    /**
     * 履歴を完全に削除するアクション
     */
    clearHistory({ commit }) {
      commit('CLEAR_HISTORY');
    },
    /**
     * 履歴内のアイテム価格を再計算する
     */
    recalculatePrices({ commit }) {
      commit('UPDATE_PRICES');
    },
  },

  mutations: {
    /**
     * stateのitemsに新しいアイテムを追加するミューテーション
     */
    ADD_ITEMS(state, newItems) {
      // 既存の履歴に新しいアイテムを連結する
      state.items = [...state.items, ...newItems];
      // ★ 更新された履歴をlocalStorageに保存する
      localStorage.setItem('orderHistory', JSON.stringify(state.items));
    },
    /**
     * 履歴を空にするミューテーション
     */
    CLEAR_HISTORY(state) {
      state.items = [];
      // ★ localStorageの履歴も削除する
      localStorage.removeItem('orderHistory');
    },

    UPDATE_PRICES(state) {
      const activePlans = JSON.parse(localStorage.getItem('activePlans')) || [];
      const targetCategories = new Set();
      activePlans.forEach((planName) => {
        if (PLAN_MAP[planName]) {
          PLAN_MAP[planName].forEach((category) => {
            targetCategories.add(category);
          });
        }
      });
      state.items.forEach((item) => {
        // original_priceがない場合に備えて現在の価格を使う
        const originalPrice = item.original_price || item.price;
        const isTargetItem = targetCategories.has(item.menus?.name);

        if (isTargetItem) {
          item.price = 0;
        } else {
          item.price = originalPrice;
        }
      });
      // ★ 更新された履歴をlocalStorageに保存
      localStorage.setItem('orderHistory', JSON.stringify(state.items));
    },
  },
};
